import { useDispatch, useSelector } from '@/stores/hooks'
import { getPoi } from '@/stores/pois'
import { setPopupOpened } from '@/stores/temp'
import { pointToLatlng } from '@lc/libgeo'
import type { Point } from 'geojson'
import { useEffect } from 'react'
import { useSearch } from 'wouter'

export function BindPoiPopup() {
	const search = useSearch()
	const params = new URLSearchParams(search)
	const poi = params.get('poi')

	const poiId = poi?.split('@')[1]

	const poiInfo = useSelector(state => (poiId ? getPoi(state, poiId) : null))
	const dispatch = useDispatch()

	useEffect(() => {
		if (!poiInfo) return
		dispatch(
			setPopupOpened({
				id: poiInfo.id,
				type: 'poi',
				pos: pointToLatlng(poiInfo.geojson as Point),
			}),
		)

		return () => {
			dispatch(setPopupOpened(null))
		}
	}, [poiInfo])

	return null
}
